var lanejCustomizer = (function () {
  window.opts = {
    isMobile: window.matchMedia("(max-width: 767px)").matches,
    formId: $('[name="currentFormId"]').val(),
    is_product_cat: $("#single_product_wrapper").data("product-tag"),
    product_handle : $("#single_product_wrapper").data("product-handle"),
    canvasWrapper: "sf-canvas-wrapper",
    is_brx_prod: is_brx,
    canvasSelector: "sf-canvas",
    fontElementHelper: "#font-style-helper",
    inputField: 'input[name="initial"]',
    alphabetInputField: 'input[name="alphabet-sticker"]',
    selectCaseSizeField: 'select[name="options[Case Size]"]',
    languageSelector: 'input[name="lanej_language"]',
    customizationSelector: 'input[name="lanej_customization"]',
    inputOptionsSelector: ".customizer__values .variant-picker__input input",
    inputFontPosition: ".prod__option--textPosition .customizer-picker__option input",
toonzAlphabetPosition: ".prod__option--alphabetPosition .customizer-picker__option input",

    fontStyleWrapper: '[data-option-type="fontFamily"]',
    fontLanguageWrapper: '[data-option-type="fontLanguage"]',
    stickerCustomizationWrapper: '[data-option-type="stickerCustomization"]',
    textColorWrapper: '[data-option-type="textColor"]',
    customTextColorWrapper: '[data-option-type="customTextColor"]',
    canvasInstance: {},
    applyFontOnHelperElement: function () {
      $(opts.fontElementHelper).css({
        fontFamily: opts.getSelectedFontFamily(),
      });
    },
    productTitle: $(".prod__title h1"),
    canvasWidth: 500,
    canvasHeight: 500,
    scaleText: 0.75,
    startLeft: 308,
    startTop: 209,
    emojiTop: 290,
    emojiHeight: 0,
    anglePosition: 0,
    defaultTextPosition: "center",
    canvasTextInstance: {},
        isPassportCover: function() {
    return this.product_handle && this.product_handle.includes('passport-cover');
  },
  
   isLuggageTag: function() {
    return this.product_handle && this.product_handle.includes('luggage-tag');
  },
    getMediaEle: function () {
      return opts.isMobile
        ? $(".sf-product-media__mobile")
        : $(".sf-product-media__desktop");
    },
    getStickerMediaEle: $(".stickers-main-div"),
    getToonzStickerMediaEle: $(".stickers-main-div.toonz-stickers-main-div"),
    getAlphabetMediaEle: $(".alphabet-main-div"),
    getSelectedColor: function () {
      return $('[name="3D Text Color"]:checked').data("option-value");
    },
    selectObject: function (objectName, instance) {
      let getRequestedObject = opts.canvasInstance
        .getObjects()
        .filter((obj, index) => {
          return obj.name.indexOf(objectName) !== -1 ? obj : false;
        });

      if (instance === "all") {
        return getRequestedObject;
      }
      return getRequestedObject[0];
    },
    // defaultFontFamily: "Baskerville10Pro",
    defaultFontFamily: "customFont",
    getSelectedFontFamily: function () {
      var _fontFamily = $(
        opts.fontStyleWrapper + " .customizer__values input:checked"
      ).data("option-value");
      console.log("_fontFamily::::", _fontFamily);
      return typeof _fontFamily != "undefined"
        ? _fontFamily
        : opts.defaultFontFamily;
    },
    getSelectedLanguage: function () {
      return $(
        opts.fontLanguageWrapper + " .customizer__values input:checked"
      ).data("option-value");
    },
    getSelectedCustomization: function () {
      return $(
        opts.stickerCustomizationWrapper + " .customizer__values input:checked"
      ).data("option-value");
    },
    getSelectedTextColor: function () {
      return $(
        opts.textColorWrapper + " .customizer__values input:checked"
      ).data("option-value");
    },
    getSelectedTextGradiantColor: function () {
      return $(
        opts.textColorWrapper + " .customizer__values input:checked"
      ).data("gradiant-value");
    },
    getSelectedTextColorShadow: function () {
      return $(
        opts.textColorWrapper + " .customizer__values input:checked"
      ).data("shadow");
    },
    getSelectedTextColorSroke: function () {
      return $(
        opts.textColorWrapper + " .customizer__values input:checked"
      ).data("stroke-color");
    },
    getSelectedTextColorStrokeWidth: function () {
      return $(
        opts.textColorWrapper + " .customizer__values input:checked"
      ).data("stroke-width");
    },
    getSelectedTextColorStrokeFill: function () {
      return $(
        opts.textColorWrapper + " .customizer__values input:checked"
      ).data("stroke-fill-color");
    },
    getSelectedTextPosition: function () {
      if ($(opts.inputFontPosition + ":checked").val() != undefined) {
        return $(opts.inputFontPosition + ":checked")
          .val()
          .toLowerCase()
          .replaceAll(" ", "-");
      }
      return opts.defaultTextPosition;
    },
       getSelectedToonzAlphabetPosition: function () {
      if ($(opts.toonzAlphabetPosition + ":checked").val() != undefined) {
        return $(opts.toonzAlphabetPosition + ":checked")
          .val()
          .toLowerCase()
          .replaceAll(" ", "-");
      }
      return opts.defaultTextPosition;
    },
    getSelected3DTextColor: function () {
      return $(
        opts.customTextColorWrapper + " .customizer__values input:checked"
      ).data("option-value");
    },
    rendered3DTextGroup: [],
    restrictToDrawOnCanvas: function () {
      let input = $(opts.inputField),
        headerHeight = opts.isMobile
          ? $(".sf-header__mobile").innerHeight()
          : $(".sf-header__desktop").innerHeight();
      if (!opts.getSelectedFontFamily()) {
        $("html,body").animate(
          {
            scrollTop: $(opts.fontStyleWrapper).offset().top - headerHeight,
          },
          500
        );
        return false;
      }

      //------- collection code start here -------
      if (
        opts.is_product_cat &&
        opts.is_product_cat == "top-right-position" &&
        input.val().length > 4
      ) {
        return false;
      }
      //------- collection code end here -------

      if (input.val() == "") {
        console.log("Please type your text..");
        input.focus();
        return false;
      }
      return true;
    },
    coordinates: {
      startTop: 209,
      startLeft: 308,
      scaleText: 0.75,
      anglePosition: 0,
      charsLimit: 0,
      fontSize: 0,
    },
    fontTypes: {
      Orbitron: {
        weight: 500,
        limit: 4,
      },
      Tourney: {
        weight: "normal",
        limit: 4,
      },
      LaLuxesScript: {
        weight: "normal",
        limit: 7,
      },
      Baskerville10Pro: {
        weight: "bold",
        limit: 4,
      },
      "Atomic Marker": {
        weight: "normal",
        limit: 7,
      },
      "Milanesa Serif": {
        weight: "bold",
        limit: 7,
      },
      Groovy: {
        weight: "normal",
        limit: 7,
      },
      Monotype: {
        weight: "normal",
        limit: 7,
      },
      Script: {
        weight: "normal",
        limit: 7,
      },
      customFont: {
        weight: 100,
        limit: 7,
      },
    },
    buildDefaultColorsList: function () {
      let colorsList = "",
        counter = 1;
      $.each(opts.defaultColors, function (i, v) {
        colorsList +=
          '<div class="prod__option-label--textColor variant-picker__input ' +
          (counter == 1 ? "active" : "") +
          '">';
        // if (v.title!='') {
        //  colorsList += 'sf__tooltip-item sf__tooltip-top';
        // }
        // colorsList += '" data-option-position="'+counter+'" data-option-type="customizer-text-color" ';
        // colorsList += '" data-option-type="color" ';
        // if (v.title!='') {
        //  colorsList += 'data-value="'+v.title+'"';
        // }
        // colorsList += '>';
        //colorsList += '<div class="sf__variant-swatch flex justify-center items-center">';
        colorsList +=
          '<input type="radio" id="customizer-text-color-' +
          counter +
          '" name="Text Color" class="Test---111" data-option-value="#' +
          i +
          '" ';

        if (v.title != "") {
          colorsList += 'value="' + v.title + '"';
        } else {
          colorsList += 'value="code=#' + i + '"';
        }

        if (v.gradient != "") {
          colorsList += ' data-gradiant-value="' + v.gradient + '"';
        }

        colorsList += ' data-shadow="' + v.shadow + '"';
        colorsList += ' data-stroke-color="' + v.stroke_color + '"';
        colorsList += ' data-stroke-width="' + v.stroke_width + '"';
        colorsList += ' data-stroke-fill-color="' + v.stroke_fill_color + '" ';

        colorsList +=
          'form="' + opts.formId + '" ' + (counter == 1 ? "checked" : "") + ">";
        // colorsList += '<label data-option-type="color" for="customizer-text-color-'+counter+'" ';
        colorsList += '<label for="customizer-text-color-' + counter + '" ';
        colorsList +=
          'class="customizer__label textColor flex items-center justify-center cursor-pointer" ';
        colorsList +=
          v.title == "White"
            ? i.startsWith("linear-gradient")
              ? ' style="background: ' + i + '; border:1px solid black;">'
              : ' style="background: #' + i + '; border:1px solid black;">'
            : i.startsWith("linear-gradient")
            ? ' style="background: ' + i + ';">'
            : ' style="background: #' + i + ';">';

        colorsList += "</label>";
        //colorsList += '</div>';
        // if (v.title!='') {
        //  colorsList += '<span class="sf__tooltip-content capitalize">'+v.title+'</span>';
        // }
        colorsList += "</div>";
        counter++;
      });
      return colorsList;
    },
    build3DColorsList: function () {
      let colorsList = "",
        counter = 1,
        colors = Object.keys(lanejCustomFonts["3d"]["en"]);
      // -------- modified color list for collections lanejCustomizer code start ------
      if (opts.is_product_cat && opts.is_product_cat != "font-customizable") {
        colors = Object.keys(lanejCustomFonts2["3d"]["en"]);
        console.log(colors);
      } else {
        colors = Object.keys(lanejCustomFonts["3d"]["en"]);
        console.log(colors);
      }
      $.each(colors, function (i, v) {
        let colorCodeReference = "",
          colorImageReference = "";

        if (opts.is_product_cat && opts.is_product_cat != "font-customizable") {
          colorCodeReference = lanejCustomFonts2["3d"]["en"][v].colorCode;
          if (lanejCustomFonts2["3d"]["en"][v].colorImage != "") {
            colorImageReference = lanejCustomFonts2["3d"]["en"][v].colorImage;
          }
        } else {
          colorCodeReference = lanejCustomFonts["3d"]["en"][v].colorCode;
          if (lanejCustomFonts["3d"]["en"][v].colorImage != "") {
            colorImageReference = lanejCustomFonts["3d"]["en"][v].colorImage;
          }
        }

        colorsList +=
          '<div class="prod__option-label--textColor variant-picker__input ' +
          (v === "yellow" ? "active" : "") +
          '">';
        colorsList +=
          '<input type="radio" id="customizer-customText-color-' +
          counter +
          '" name="3D Text Color" data-option-value="' +
          v.toLowerCase() +
          '" ';
        colorsList += 'value="' + v.toUpperCase() + '"';
        colorsList +=
          'form="' +
          opts.formId +
          '" ' +
          (v === "yellow" ? "checked" : "") +
          ">";
        colorsList +=
          '<label for="customizer-customText-color-' + counter + '" ';
        colorsList +=
          'class="customizer__label textColor flex items-center justify-center cursor-pointer" ';

        if (colorImageReference) {
          colorsList +=
            ' style="background-size:contain;background-image: url(' +
            colorImageReference +
            ')">';
        } else {
          colorsList +=
            ' style="background-color: ' + colorCodeReference + '">';
        }

        colorsList += "</label>";
        colorsList += "</div>";
        counter++;
      });

      // --------  modified color list for collections lanejCustomizer code start ------

      $(".customTextColor-option-values").html(colorsList);
    },
    defaultColors: default_colors_list,
    renderColorsList: function () {
      $(".textColor-option-values").html(opts.buildDefaultColorsList());
    },
    totalWidthOf3DText: function () {
      var chars = $(opts.inputField).val().split(""),
        totalWidth = 0,
        scaleText = (opts.coordinates.scaleText * opts.canvasWidth) / 608,
        spacing = 4,
        active3dColor = opts.getSelected3DTextColor();
      $.each(chars, function (i, v) {
        // let imageData = opts.get3DTextImageData('3d', 'en', active3dColor, v);
        let imageData = opts.get3DTextImageData(
          "3d",
          opts.getSelectedLanguage(),
          active3dColor,
          v
        );
        console.log("imageData.width",imageData.width)
        totalWidth = totalWidth + imageData.width * scaleText + spacing;
      });
      return totalWidth;
    },
    totalWidthOfAlphabetText:function(){
      var chars = $(opts.alphabetInputField).val().split(""),
        totalWidth = 0,
        scaleText = (opts.coordinates.scaleText * opts.canvasWidth) / 608,
        spacing = 4,
        active3dColor = opts.getSelected3DTextColor();

          $.each(chars, function (i, v) {
     let char = v.toUpperCase();
     console.log("char1111",char)
     let letterData = lanejCustomAlphabet[char][0];
     console.log("letterData",letterData.width)
     totalWidth = totalWidth + letterData.width * scaleText + spacing;
  });
      return totalWidth
    },

    get3DTextImageData: function (fontType, language, color, character) {
      console.log(fontType, language, color, character);
      if (fontType == "3d") {
        return lanejCustomFonts[fontType][language][color][
          character.toLowerCase()
        ];
      } else {
        if (opts.getSelectedLanguage() == "en") {
          return lanejCustomFonts2[fontType][language][color][
            character.toLowerCase()
          ];
        }

        return lanejCustomFonts2[fontType][language][color][character];
      }

      // if (opts.is_product_cat && opts.is_product_cat != "font-customizable") {
      //   if (
      //     opts.is_product_cat == "top-right-position" &&
      //     opts.getSelectedLanguage() == "en"
      //   ) {
      //     return lanejCustomFonts2[fontType][language][color][
      //       character.toLowerCase()
      //     ];
      //   }

      //   return lanejCustomFonts2[fontType][language][color][character];
      // }
      // return lanejCustomFonts[fontType][language][color][
      //   character.toLowerCase()
      // ];
    },
    setNormalTextObjectValue: function (canvasObject, text) {
      canvasObject.set("text", text);
      // opts.canvasInstance.renderAll();
    },
    setCoordinatesBasedOnFont: function (fontType) {
      console.log('from -> setCoordinatesBasedOnFont -> ', fontType);

      if (fontType === "customFont") {
        opts.specialFontsSetCoordinates();
      } else if(fontType === "toonzAlphabet"){
         opts.toonzAlphabetSetCoordinates(selectedAlphabets);
      }
       else {
        opts.normalFontsSetCoordinates();

        let activeTextObject = opts.selectObject("normal-font", "first"),
          text = $(opts.inputField).val();

        if (activeTextObject != undefined) {
          if (activeTextObject.text != "") {
            opts.setNormalTextObjectValue(activeTextObject, text);
          } else {
            // add normal text on canvas
            opts.renderNormalTextOnCanvas(text);
          }
        }
      }
    },

    normalFontsSetCoordinates: function () {
      $(opts.textColorWrapper).slideDown("fast");
      $(opts.customTextColorWrapper).slideUp("fast");

      // set coordinates based on font family
      var fontSize = (100 * opts.canvasWidth) / 608,
        hEle = $(opts.fontElementHelper),
        tPos = opts.getSelectedTextPosition(),
        startPos = opts.canvasWidth / 2, // startLeft
        topPos = opts.canvasHeight / 2, // startTop
        angel = 0,
        activeTextObject = opts.selectObject("normal-font", "first");

      // remove the existing custom 3d fonts
      opts.removeExistingCustomFontText(
        opts.selectObject("alphabet_svg", "all")
      );

      if (tPos == "center-small" || tPos == "center-bottom-small") {
        fontSize = (45 * opts.canvasWidth) / 608;
      } else if (tPos == "right-bottom") {
        fontSize = (120 * opts.canvasWidth) / 608;
      } else {
        fontSize = (100 * opts.canvasWidth) / 608;
      }

      hEle.css("font-size", fontSize + "px");
      var hEleWidth = hEle[0].clientWidth; // reqSpace

      //console.log('tPos: ', tPos);
      //console.log('1: left: ', startPos);

      // Font Size
       if (tPos === "center" || tPos === "center-small" || tPos === "center-bottom-small") {
    /* centersmall || centerbottomsmall || centerbig */
    if (opts.getSelectedFontFamily() == "Monotype" && tPos === "center") {
        fontSize = (85 * opts.canvasWidth) / 608;
    }
    
    var availableSpace = (280 * opts.canvasWidth) / 608,
        factor = 2;
    
    // Get the text content to calculate proper width
    var textContent = hEle.text() || hEle.val() || '';
    
    // For Monotype font, calculate width more precisely
    if (opts.getSelectedFontFamily() == "Monotype") {
        // Create a temporary element to measure text width more accurately
        var tempEle = $('<span>')
            .css({
                'font-family': 'Monotype',
                'font-size': fontSize + 'px',
                'visibility': 'hidden',
                'position': 'absolute',
                'white-space': 'nowrap'
            })
            .text(textContent)
            .appendTo('body');
        
        hEleWidth = tempEle.outerWidth();
        tempEle.remove();
    } else {
        hEleWidth = hEle[0].clientWidth;
    }
      if(opts.product_handle.includes('luggage-tag')){
            console.log("gethererere")
            availableSpace = (180 * opts.canvasWidth) / 608
            if(tPos === "center-small" ||tPos === "center-bottom-small"){
             availableSpace = (150 * opts.canvasWidth) / 608
            }else{
              availableSpace = (180 * opts.canvasWidth) / 608
            }
          }
          if(opts.product_handle.includes("passport-cover")){
            console.log("gethererere")
            availableSpace = (320 * opts.canvasWidth) / 608
          }
    
    while (hEleWidth > availableSpace) {
        fontSize = ((fontSize - factor) * opts.canvasWidth) / 608;
        hEle.css("font-size", fontSize + "px");
        factor++;
        
        // Recalculate width with new font size
        if (opts.getSelectedFontFamily() == "Monotype") {
            var tempEle = $('<span>')
                .css({
                    'font-family': 'Monotype',
                    'font-size': fontSize + 'px',
                    'visibility': 'hidden',
                    'position': 'absolute',
                    'white-space': 'nowrap'
                })
                .text(textContent)
                .appendTo('body');
            
            hEleWidth = tempEle.outerWidth();
            tempEle.remove();
        } else {
            hEleWidth = hEle[0].clientWidth;
        }
        
        if (hEleWidth <= availableSpace) {
            break;
        }
    }
    
    // Ensure proper centering after font size adjustment
    if (opts.getSelectedFontFamily() == "Monotype") {
        hEle.css({
            'text-align': 'center',
            'display': 'block',
            'margin': '0 auto'
        });
    }
}

      //console.log('2: left: ', startPos);

      // Text Position

      if (tPos === "center") {
        // centerbig || centersmall
        topPos = topPos - (40 * opts.canvasHeight) / 784;
        startPos = startPos - (hEleWidth * opts.canvasWidth) / 608;

            if(opts.product_handle.includes('luggage-tag')){
            topPos = (500 * opts.canvasHeight) / 828;
            // startPos = startPos - (hEleWidth * opts.canvasWidth) / 900;
          }
             if(opts.product_handle.includes("passport-cover")){
                startPos = startPos + 20
          }

        console.log(":gettStartPos", startPos, hEleWidth, opts.canvasWidth);
        // if (opts.getSelectedFontFamily() == "LaLuxesScript") {
        //   fontSize = (80 * opts.canvasWidth) / 608;
        // }
      } else if (tPos === "center-small") {
        // centerbig || centersmall
        topPos = topPos - (40 * opts.canvasHeight) / 784;
        if (opts.getSelectedFontFamily() == "LaLuxesScript") {
          fontSize = (60 * opts.canvasWidth) / 608;
          startPos = startPos - 20 - (hEleWidth * opts.canvasWidth) / 608;
        }else if (opts.getSelectedFontFamily() == "Script") {
          fontSize = (65 * opts.canvasWidth) / 608;
          startPos = startPos - 120 - (hEleWidth * opts.canvasWidth) / 608;
        } else {
          startPos = startPos - (hEleWidth * opts.canvasWidth) / 608;
        }
           if(opts.product_handle.includes('luggage-tag')){
             topPos = (500 * opts.canvasHeight) / 828;
          }
              if(opts.product_handle.includes('passport-cover')){
             topPos = (400 * opts.canvasHeight) / 828;
          }
      } 
        else if (tPos === "vertical-center") {

  const w = opts.canvasWidth;
  const h = opts.canvasHeight;
  const fontFamily = opts.getSelectedFontFamily();

  // -----------------------------
  // FONT SIZE
  // -----------------------------
  const fontSizeMap = {
    "Milanesa Serif": 90,
    "Atomic Marker": 100,
    "LaLuxesScript": 80,
    "Script": 160
  };

  let baseFontSize = fontSizeMap[fontFamily] || 100;
  fontSize = (baseFontSize * w) / 608;

  hEle.css("font-size", fontSize + "px");
  hEleWidth = hEle[0].clientWidth;

  let canvasStart, blankSpace, cameraStart, canvasEnd;

  // =====================================================
  // PASSPORT COVER
  // =====================================================
  if (opts.product_handle.includes("passport-cover")) {

    canvasStart = h * 0.957;
    blankSpace  = h * 0.383;
    cameraStart = h * 0.472;
    canvasEnd   = h * 0.153;

    // Resize if needed
    let iterations = 0;
    while (hEleWidth > blankSpace && iterations < 50) {
      fontSize = fontSize * 0.95;
      hEle.css("font-size", fontSize + "px");
      hEleWidth = hEle[0].clientWidth;
      iterations++;
    }

    startPos = (w - fontSize) / 2;
      startPos += (20 * w) / 608; 
    topPos   = canvasStart - (canvasStart - canvasEnd) / 2;

    // Script adjustment
    if (fontFamily === "Script") {
      topPos  += (h * 0.128);
      startPos -= (20 * w) / 608;
    }

    // Camera collision
    if (topPos - hEleWidth / 2 < cameraStart) {
      let diff = cameraStart - (topPos - hEleWidth / 2);
      topPos += diff;

      let remainingSpace = canvasStart - (topPos + hEleWidth / 2);
      topPos += remainingSpace / 2;
    }

  }

  // =====================================================
  // LUGGAGE TAG
  // =====================================================
  else if (opts.product_handle.includes("luggage-tag")) {

    canvasStart = h * 0.820;
    blankSpace  = h * 0.300;
    cameraStart = h * 0.350;
    canvasEnd   = h * 0.153;

    let iterations = 0;
    while (hEleWidth > blankSpace && iterations < 50) {
      fontSize = fontSize * 0.95;
      hEle.css("font-size", fontSize + "px");
      hEleWidth = hEle[0].clientWidth;
      iterations++;
    }

    startPos = (w - fontSize) / 2;
    topPos   = canvasStart - (canvasStart - canvasEnd) / 2;

    if (fontFamily === "Script") {
      topPos  += (h * 0.128);
      startPos -= (20 * w) / 608;
    }

    if (topPos - hEleWidth < cameraStart) {
      let diff = cameraStart - (topPos - hEleWidth);
      topPos += diff;

      let remainingSpace = canvasStart - (topPos + hEleWidth / 2);
      topPos += remainingSpace / 2;
    }

    // Extra luggage adjustment
    const adjustment = h / 608;
    topPos += adjustment;

    let remainingSpace = canvasStart - (topPos + adjustment - (100 * h) / 784);
    topPos += remainingSpace / 2;
  }

  // =====================================================
  // DEFAULT PRODUCTS (EXACT OLD WORKING LOGIC)
  // =====================================================
  else {

    canvasStart = (660 * h) / 784;
    blankSpace  = (390 * h) / 784;
    cameraStart = (270 * h) / 784;
    canvasEnd   = (120 * h) / 784;

    // OLD resize logic (kept exactly)
    if (hEleWidth > blankSpace) {
      let factor = 2;
      while (hEleWidth > blankSpace) {
        fontSize = ((fontSize - factor) * w) / 608;
        hEle.css("font-size", fontSize + "px");
        factor++;
        hEleWidth = hEle[0].clientWidth;
        if (hEleWidth <= blankSpace) break;
      }
    }

    startPos = (w - fontSize) / 2;
    topPos   = canvasStart - (canvasStart - canvasEnd) / 2;

    if (fontFamily === "Script") {
      topPos += (100 * h) / 784;
      startPos -= 20;
    }

    if (topPos - hEleWidth / 2 < cameraStart) {
      let diff = cameraStart - (topPos - hEleWidth / 2);
      topPos += diff;

      let remainingSpace = canvasStart - (topPos + hEleWidth / 2);
      topPos += remainingSpace / 2;
    }

    if (fontFamily === "Groovy") {
      startPos += 12;
    }

    // IMPORTANT: restore old centering
    topPos += hEleWidth / 2;
  }

  angel = -90;
}
else if (tPos === "right-bottom") {
  const w = opts.canvasWidth;
  const h = opts.canvasHeight;
  const fontFamily = opts.getSelectedFontFamily();
  const textLength = $(opts.inputField).val().length;
  
  // Dynamic font size calculation
  const fontSizeMap = {
    "LaLuxesScript": 80,
    "Script": 160
  };
  
  const baseFontSize = fontSizeMap[fontFamily] || 110;
  fontSize = (baseFontSize * w) / 608;
  
  // Apply font size reduction for luggage tags
   if(opts.product_handle.includes('luggage-tag')){
    fontSize = fontSize * 0.85; // Reduce font size by 15% for luggage tags
  }
  
  // Dynamic blank space calculation based on product type
  let blankSpace;
  if(opts.product_handle.includes("passport-cover")){
    blankSpace = h * 0.446; // 350/784 ≈ 0.446
  } else if(opts.product_handle.includes('luggage-tag')){
    blankSpace = h * 0.255; // 200/784 ≈ 0.255
  } else {
    blankSpace = h * 0.497; // 390/784 ≈ 0.497
  }
  
  // Apply font size and get actual element width
  hEle.css("font-size", fontSize + "px");
  hEleWidth = hEle[0].clientWidth;
  
  // Font size reduction logic - different for passport cover
  if (hEleWidth > blankSpace) {
    let iterations = 0;
    const maxIterations = 50;
    
    if(opts.product_handle.includes("passport-cover")){
      // Passport cover uses fixed factor
      const factor = 2;
      while (hEleWidth > blankSpace && iterations < maxIterations) {
        fontSize = fontSize - factor;
        hEle.css("font-size", fontSize + "px");
        hEleWidth = hEle[0].clientWidth;
        iterations++;
      }
    } else {
      // Other products use percentage reduction
      while (hEleWidth > blankSpace && iterations < maxIterations) {
        fontSize = fontSize * 0.95; // Reduce by 5%
        hEle.css("font-size", fontSize + "px");
        hEleWidth = hEle[0].clientWidth;
        iterations++;
      }
    }
  }
  
  // Calculate base start position
  startPos = (440 * w) / 608;
  startPos = startPos - fontSize;
  
  // Product-specific adjustments
  const topSpace = 255;
  
 if(opts.product_handle.includes("passport-cover")){
    startPos = (470 * h) / 968;
    
    // Font-specific adjustment
    if (fontFamily === "Script") {
      startPos = startPos - (70 * w) / 608;
    }
    
    // Text length adjustment
    if (textLength > 5) {
      startPos = startPos + (20 * w) / 608;
    }
    
    topPos = topPos + (topSpace * h) / 850;
  } else if(opts.product_handle.includes('luggage-tag')){
    startPos = startPos - (30 * w) / 608;
    topPos = topPos + (topSpace * h) / 784 + (20 * h) / 784; // Increased top position
  } else {
    topPos = topPos + (topSpace * h) / 784;
  }
  
  angel = -90;
      } else if (tPos === "center-bottom-small") {
        if (opts.getSelectedFontFamily() == "LaLuxesScript") {
          fontSize = (60 * opts.canvasWidth) / 608;
          topPos = topPos + (200 * opts.canvasWidth) / 608;
        } else if (opts.getSelectedFontFamily() == "Script") {
          fontSize = (65 * opts.canvasWidth) / 608;
          if(opts.product_handle.includes("passport-cover")){
            topPos = topPos + (200 * opts.canvasWidth) / 650;
          }
          else if (opts.product_handle.includes('luggage-tag')) {
           topPos = topPos + (200 * opts.canvasWidth) / 650;
          }
          else{
            topPos = topPos + (220 * opts.canvasWidth) / 608;
          }
        } else {
             if(opts.product_handle.includes("passport-cover")){
          // startPos = (470 * opts.canvasHeight) / 968;
          topPos = topPos + (200 * opts.canvasWidth) / 650;
          }
       else if (opts.product_handle.includes('luggage-tag')) {
  const scaleBase = Math.min(opts.canvasWidth, opts.canvasHeight);
  topPos = topPos + (270 * opts.canvasWidth) / 650;
  // topPos += (250 * scaleBase) / 668;
}

          
          else{
            topPos = topPos + (235 * opts.canvasWidth) / 608;
          }
        }
        startPos = startPos - (hEleWidth * opts.canvasWidth) / 608 ;
        angel = 0;
      }

      //console.log('3: left: ', startPos);

      if (activeTextObject != undefined) {
        if (
          tPos == "center" ||
          tPos == "center-small" ||
          tPos == "center-bottom-small"
        ) {
          startPos = opts.canvasWidth / 2;
          startPos = startPos - hEleWidth / 2
             if(opts.product_handle.includes("passport-cover")){
              startPos = startPos + 10;
             }else if(opts.product_handle.includes("luggage-tag")){
              startPos = startPos + 7;
             } 
             
          if (
            opts.getSelectedFontFamily() == "LaLuxesScript" &&
            (tPos == "center-small" || tPos == "center-bottom-small")
          ) {
            startPos = startPos - 15; // activeTextObject.width/2
          }

              if (
            opts.getSelectedFontFamily() == "Script" &&
            (tPos == "center-small" || tPos == "center-bottom-small")
          ) {
            startPos = startPos - 15; // activeTextObject.width/2
          }
        }

        if (tPos == "vertical-center") {

           if(opts.product_handle.includes("luggage-tag")){
              startPos = startPos + 5;
             } 

          // centerbigvert
          activeTextObject.top =
            activeTextObject.top + (10 * opts.canvasHeight) / 784;
        }
      }

      //console.log('4: left: ', startPos);

      console.log("top:", topPos, "left:", startPos, "tPos", tPos);

      opts.coordinates.startTop = topPos;
      opts.coordinates.startLeft = startPos;
      opts.coordinates.anglePosition = angel;
      opts.coordinates.fontSize = fontSize;
    },

    specialFontsSetCoordinates: function () {
      $(opts.textColorWrapper).slideUp("fast");
      $(opts.customTextColorWrapper).slideDown("fast");

      // if ($(opts.inputField).val() === "") {
      //   return;
      // }

      setCoordinates();

      var hEle = $(opts.fontElementHelper),
        tPos = opts.getSelectedTextPosition(),
        startPos = opts.canvasWidth,
        topPos = opts.canvasHeight,
        angel = 0,
        activeTextObject = opts.selectObject("normal-font", "first"),
        scaleText = (opts.coordinates.scaleText * opts.canvasWidth) / 608,
        spacing = 4,
        totalWidth = opts.totalWidthOf3DText(),
        requireSpace = totalWidth / 2,
        textCharacters = $(opts.inputField).val().split("");
        console.log("totalWidth1",totalWidth);
        
        if (activeTextObject != undefined) {
          if (activeTextObject.text != "") {
          opts.setNormalTextObjectValue(activeTextObject, "");
        }
      }

      


      spacing = (4 * opts.canvasWidth) / 608;

      if (tPos == "center") {
            if(opts.product_handle.includes('luggage-tag')){

        var maxwidth = (200 * opts.canvasWidth) / 608;

        if (totalWidth > maxwidth) {

          for (var i = 1; i < 50; i++) {

            opts.coordinates.scaleText = opts.coordinates.scaleText - i / 100;

            totalWidth = opts.totalWidthOf3DText();

            requireSpace = totalWidth / 2;

            if (totalWidth <= maxwidth) {

              break;

            }

          }

          scaleText = (opts.coordinates.scaleText * opts.canvasWidth) / 608;

          topPosition = (100 * opts.canvasHeight) / 784;

        }

      }else{

         var maxwidth = (320 * opts.canvasWidth) / 608;
        if (totalWidth > maxwidth) {
          for (var i = 1; i < 50; i++) {
            opts.coordinates.scaleText = opts.coordinates.scaleText - i / 100;
            totalWidth = opts.totalWidthOf3DText();
            requireSpace = totalWidth / 2;
            if (totalWidth <= maxwidth) {
              break;
            }
          }
          scaleText = (opts.coordinates.scaleText * opts.canvasWidth) / 608;
        }
      }
      }
       console.log("startingPosition222",startingPosition,topPosition,opts.coordinates.scaleText)
      if (tPos == "center-bottom-small" || tPos == "center-small") {
        var maxwidth = (250 * opts.canvasWidth) / 608;
        if(opts.product_handle.includes('luggage-tag')){
         var maxwidth = (180 * opts.canvasWidth) / 608;
        }
        if (totalWidth > maxwidth) {
          for (var i = 1; i < 50; i++) {
            opts.coordinates.scaleText = opts.coordinates.scaleText - i / 100;
            totalWidth = opts.totalWidthOf3DText();
            requireSpace = totalWidth / 2;
            if (totalWidth <= maxwidth) {
              break;
            }
          }
          scaleText = (opts.coordinates.scaleText * opts.canvasWidth) / 608;
        }
        

         if(opts.product_handle.includes("passport-cover")){

             topPosition = (200 * opts.canvasHeight) / 968;

          }
      }

     if (tPos == "vertical-center") {
    var originalScale = opts.coordinates.scaleText;
    var workingScale = originalScale;
    var isLuggage = opts.product_handle.includes("luggage-tag");
    var isPassport = opts.product_handle.includes("passport-cover");
    
    var maxwidth, topPosition, startingPositionOffset = 0;
    
    /* ------------------------- PRODUCT SPECIFIC SETTINGS --------------------------*/
    if (isLuggage) {
        maxwidth = (250 * opts.canvasHeight) / 784;
        topPosition = (690 * opts.canvasHeight) / 830;
        if (opts.canvasWidth > 680) {
            startingPositionOffset = 20;
        } else {
            startingPositionOffset = 10;
        }
    } else if (isPassport) {
        topPosition = (690 * opts.canvasHeight) / 850;
        maxwidth = (428 * opts.canvasHeight) / 784;
        startingPositionOffset = 10;
    } else {
        // Phone (original behavior)
        topPosition = (690 * opts.canvasHeight) / 784;
        maxwidth = (428 * opts.canvasHeight) / 784;
        startingPositionOffset = 0;
    }
    
    angel = -90;
    
    /* ------------------------- WIDTH OVERFLOW HANDLING --------------------------*/
    // Check if we need to scale down first
    var tempTotalWidth = opts.totalWidthOf3DText();
    
    if (tempTotalWidth > maxwidth) {
        for (var i = 1; i < 50; i++) {
            workingScale = originalScale - i / 100;
            opts.coordinates.scaleText = workingScale;
            tempTotalWidth = opts.totalWidthOf3DText();
            if (tempTotalWidth < maxwidth) {
                break;
            }
        }
        // Restore original scale for now
        opts.coordinates.scaleText = originalScale;
    }
    
    /* ------------------------- CALCULATE FINAL POSITIONS --------------------------*/
    // Calculate startingPosition using the ORIGINAL formula structure
    var baseStartingPosition = (308 * opts.canvasWidth) / 608;
    var finalScaleText = (workingScale * opts.canvasWidth) / 608;
    var requiredWidth = finalScaleText * 272;
    
    // Apply the centering logic exactly like original
    requiredWidth = requiredWidth / 2;
    var startingPosition = baseStartingPosition - requiredWidth + startingPositionOffset;
    
    // Apply the working scale permanently
    scaleText = finalScaleText;
    opts.coordinates.scaleText = workingScale; // or keep original if you prefer
    
    totalWidth = tempTotalWidth;
    
    /* ------------------------- PERFECT CENTER BALANCE --------------------------*/
    if (maxwidth > totalWidth) {
        var diff = maxwidth - totalWidth;
        diff = diff / 2;
        topPosition -= diff;
    }
} else if (tPos == "right-bottom") {
        var diff = 273 * scaleText,
          startingPosition = (opts.coordinates.startLeft * opts.canvasWidth) / 608 - diff,
          topPosition = (opts.coordinates.startTop * opts.canvasHeight) / 784;

          
           if(opts.product_handle.includes('luggage-tag')){

            topPosition = (690 * opts.canvasHeight) / 800;

            startingPosition = (opts.coordinates.startLeft * opts.canvasWidth) / 620 - diff;

             maxwidth = (260 * opts.canvasHeight) / 784; 



             if (totalWidth > maxwidth) {

          for (var i = 1; i < 50; i++) {

            opts.coordinates.scaleText = opts.coordinates.scaleText - i / 100;

            totalWidth = opts.totalWidthOf3DText();

            if (totalWidth < maxwidth) {

              break;

            }

          }

          scaleText = (opts.coordinates.scaleText * opts.canvasWidth) / 608;

        }


          }

          if(opts.product_handle.includes("passport-cover")){
             topPosition = (opts.coordinates.startTop * opts.canvasHeight) / 825;
            startingPosition =
            (opts.coordinates.startLeft * opts.canvasWidth) / 550 - diff;
          }


          angel = -90;
      } else {
        // console.log(opts.startLeft, opts.canvasWidth, requireSpace);
        var startingPosition = (opts.coordinates.startLeft * opts.canvasWidth) / 608 - requireSpace;

        if(opts.product_handle.includes('luggage-tag')){

          topPosition = (opts.coordinates.startTop * opts.canvasHeight) / 570;
          startingPosition = startingPosition + 8

          if (tPos == "center-bottom-small") {

            topPosition = (opts.coordinates.startTop * opts.canvasHeight) / 768;
            startingPosition = startingPosition - 5
          }else if(tPos == "center-small"){
            startingPosition = startingPosition - 5
          }
          }else{

        topPosition = (opts.coordinates.startTop * opts.canvasHeight) / 784;

        if(opts.product_handle.includes("passport-cover")){

          topPosition = (opts.coordinates.startTop * opts.canvasHeight) / 720;
          startingPosition = startingPosition + 10
          

          if ( tPos == "center-small") {
            topPosition = (opts.coordinates.startTop * opts.canvasHeight) / 700;
          }else if(tPos == "center-bottom-small"){
            topPosition = (opts.coordinates.startTop * opts.canvasHeight) / 825;
          }
        }
        // topPosition = (opts.coordinates.startTop * opts.canvasHeight) / 784;

        console.log("startingPosition1",startingPosition,topPosition,opts.coordinates.startLeft,requireSpace)
      }
    }

      // --------  set angle for signature key chain start ---------
      if (opts.is_product_cat && opts.is_product_cat == "signature-keychain") {
        if ($(opts.inputField).val().length > 4) {
          return false;
        }
        angel = -90;
        startingPosition = 280;
        topPosition = 590;
      }
      if (
        opts.is_product_cat &&
        opts.is_product_cat == "top-right-position" &&
        textCharacters.length > 4
      ) {
        return false;
      }
      // -------- set angle for signature key chain end -----------

      fabric.Object.prototype.transparentCorners = false;

      // remove the existing custom fonts
      opts.removeExistingCustomFontText(
        opts.selectObject("alphabet_svg", "all")
      );

      if (opts.getSelectedLanguage() == "ar") {
        textCharacters = textCharacters.reverse();
      }
      for (var i = 0; i < textCharacters.length; i++) {
        var char = textCharacters[i];
        imageData = opts.get3DTextImageData(
          "3d",
          opts.getSelectedLanguage(),
          opts.getSelected3DTextColor(),
          char
        );
        var properties = {
          left: startingPosition,
          top: topPosition,
          scaleX: scaleText,
          scaleY: scaleText,
          selectable: false,
          evented: false,
          angle: angel,
          name: "alphabet_svg" + i.toString(),
          crossOrigin: "Anonymous",
        };
        console.log("new-properties",properties,imageData.link,)

        if (imageData.link) {
          $(opts.inputField).prop("disabled", true);

          fabric.Image.fromURL(
            imageData.link,
            function (oImg) {
              opts.canvasInstance.add(oImg);
              opts.rendered3DTextGroup.push(oImg);
              $(opts.inputField).prop("disabled", false);
              $(opts.inputField).focus();
            },
            properties
          );

          if (angel != 0) {
            topPosition = topPosition - imageData.width * scaleText - spacing;
          } else {
            startingPosition =
              startingPosition + imageData.width * scaleText + spacing;
          }
        }

        //console.log('startingPosition--loop  ', startingPosition);
      }
    },

    toonzAlphabetSetCoordinates: function () {
      $(opts.textColorWrapper).slideUp("fast");
      $(opts.customTextColorWrapper).slideDown("fast");

      // if ($(opts.inputField).val() === "") {
      //   return;
      // }

      setCoordinates('toonzAlphabet');

      var hEle = $(opts.fontElementHelper),
        tPos = opts.getSelectedToonzAlphabetPosition(),
        startPos = opts.canvasWidth,
        topPos = opts.canvasHeight,
        angel = 0,
        activeTextObject = opts.selectObject("normal-font", "first"),
        scaleText = (opts.coordinates.scaleText * opts.canvasWidth) / 608,
        spacing = 4,
        totalWidth = opts.totalWidthOfAlphabetText(),
        requireSpace = totalWidth / 2,
        textCharacters = $(opts.alphabetInputField).val().split("");
        console.log("totalWidth1",totalWidth);
        
        if (activeTextObject != undefined) {
          if (activeTextObject.text != "") {
          opts.setNormalTextObjectValue(activeTextObject, "");
        }
      }

      


      spacing = (4 * opts.canvasWidth) / 608;
// if (tPos == "center") {

//     var isLuggageTag = opts.product_handle.includes("luggage-tag");
//     var isPassport = opts.product_handle.includes("passport-cover");
//     var isPouch = opts.product_handle == "pocket-pouch";

//     var maxwidth = isLuggageTag
//         ? (200 * opts.canvasWidth) / 608
//         : (320 * opts.canvasWidth) / 608;

//     // ✅ Do NOT permanently mutate original scale
//     var originalScale = opts.coordinates.scaleText;
//     var workingScale = originalScale;

//     if (totalWidth > maxwidth) {

//         var tempScale = originalScale;

//         for (var i = 1; i < 50; i++) {

//             tempScale = originalScale - i / 100;
//             opts.coordinates.scaleText = tempScale;

//             totalWidth = opts.totalWidthOfAlphabetText();

//             if (totalWidth <= maxwidth) {
//                 break;
//             }
//         }

//         // restore original immediately
//         opts.coordinates.scaleText = originalScale;

//         workingScale = tempScale;
//     }

//     scaleText = (workingScale * opts.canvasWidth) / 608;

//     var startingPosition = (308 * opts.canvasWidth) / 608;

//     /* -----------------------
//        TOP POSITION CONTROL
//     ------------------------*/

//     if (isLuggageTag) {

//         topPosition = (opts.coordinates.startTop * opts.canvasHeight) / 600;

//         var scaleDifference = originalScale - workingScale;

//         topPosition = topPosition + (scaleDifference * opts.canvasHeight * 0.5);

//         startingPosition = startingPosition + 50;
//     }

//     else if (isPassport) {

//         // 🔥 Increase passport vertical position here
//         topPosition = (opts.coordinates.startTop * opts.canvasHeight) / 784;

//         // Increase by fixed offset (adjust number as needed)
//         topPosition = topPosition + (30 * opts.canvasHeight / 784);

//         // You can increase 30 → 40 or 50 if needed
//     }

//     else if (isPouch) {

//         topPosition = (opts.coordinates.startTop * opts.canvasHeight) / 700;
//     }

//     else {

//         topPosition = (opts.coordinates.startTop * opts.canvasHeight) / 784;
//     }
// }
if (tPos == "center") {

    if (opts.product_handle.includes('luggage-tag')) {
        var maxwidth = (200 * opts.canvasWidth) / 608;
    } else {
        var maxwidth = (320 * opts.canvasWidth) / 608;
    }
    
    // Store original scale for comparison
    var originalScale = opts.coordinates.scaleText;
  
    if (totalWidth > maxwidth) {
        for (var i = 1; i < 50; i++) {
            opts.coordinates.scaleText = opts.coordinates.scaleText - i / 100;
            totalWidth = opts.totalWidthOfAlphabetText();
            requireSpace = totalWidth / 2;
            if (totalWidth <= maxwidth) {
                break;
            }
        }
        scaleText = (opts.coordinates.scaleText * opts.canvasWidth) / 608;
    }

    var startingPosition = (308 * opts.canvasWidth) / 608;

    // Set topPosition and adjust for text scaling
    if (opts.product_handle.includes('luggage-tag')) {

        topPosition = (opts.coordinates.startTop * opts.canvasHeight) / 600;

        var scaleDifference = originalScale - opts.coordinates.scaleText;
        topPosition = topPosition + (scaleDifference * opts.canvasHeight * 0.5);

        startingPosition = startingPosition + 50;

    } 
    else if (opts.product_handle.includes('passport-cover')) {

        topPosition = (opts.coordinates.startTop * opts.canvasHeight) / 784;

        // 🔥 Added extra top space for passport
        topPosition = topPosition + (30 * opts.canvasHeight / 784);

        // Change 30 → 40 or 50 if you want it lower

    }
    else if (opts.product_handle == "pocket-pouch") {

        topPosition = (opts.coordinates.startTop * opts.canvasHeight) / 700;

    } 
    else {

        topPosition = (opts.coordinates.startTop * opts.canvasHeight) / 784;
    }
}
  
      if (tPos == "center-bottom-small" || tPos == "center-small") {
        var maxwidth = (250 * opts.canvasWidth) / 608;
        if (totalWidth > maxwidth) {
          for (var i = 1; i < 50; i++) {
            opts.coordinates.scaleText = opts.coordinates.scaleText - i / 100;
            totalWidth = opts.totalWidthOfAlphabetText();
            requireSpace = totalWidth / 2;
            if (totalWidth <= maxwidth) {
              break;
            }
          }
          scaleText = (opts.coordinates.scaleText * opts.canvasWidth) / 608;
        }
      }

     if (tPos == "vertical-center") {
  var topPosition = (590 * opts.canvasHeight) / 784,
    maxwidth = (380 * opts.canvasHeight) / 784,
    angel = -90;

  if (opts.product_handle == "trinket-trays") {
    maxwidth = (560 * opts.canvasHeight) / 784;
  }
  if (opts.product_handle == "pocket-pouch" || opts.product_handle.includes("passport-cover")) {
    maxwidth = (480 * opts.canvasHeight) / 784;
  }
  if (opts.product_handle.includes('luggage-tag')) {
    maxwidth = (250 * opts.canvasHeight) / 784;
    topPosition = (585 * opts.canvasHeight) / 784;
  }

  // Scale down text if it exceeds maxwidth
  if (totalWidth > maxwidth) {
    for (var i = 1; i < 50; i++) {
      opts.coordinates.scaleText = opts.coordinates.scaleText - i / 100;
      totalWidth = opts.totalWidthOfAlphabetText();
      if (totalWidth < maxwidth) {
        break;
      }
    }
    scaleText = (opts.coordinates.scaleText * opts.canvasWidth) / 608;
  }
  
  // Apply scale factor
  scaleText = scaleText * 0.85;
  
  // Calculate position AFTER scaling to keep text centered
  var requiredWidth = scaleText * 272;
  requiredWidth = requiredWidth / 3;
  var startingPosition = (290 * opts.canvasWidth) / 608 - requiredWidth;
  
  // Add offset for specific products
  if (opts.product_handle == "pocket-pouch" || opts.product_handle.includes("passport-cover")) {
    startingPosition = startingPosition + 20;
  }else if(opts.product_handle.includes('luggage-tag')){
    startingPosition = startingPosition + 10;
  }

  // Adjust top position based on available space
  if (maxwidth > totalWidth) {
    var diff = maxwidth - totalWidth;
    diff = diff / 3;
    topPosition -= diff;
  }
}
else if (tPos == "right-bottom") {

  var isPassport = opts.product_handle.includes("passport-cover");
  var isLuggage  = opts.product_handle.includes("luggage-tag");

  var angel = -90;
  var maxwidth;
  var diff;
  var startingPosition;
  var topPosition;

  // =====================================================
  // DEFAULT PRODUCTS (EXACT OLD WORKING LOGIC)
  // =====================================================
  if (!isPassport && !isLuggage &&
      opts.product_handle != "trinket-trays" &&
      opts.product_handle != "pocket-pouch") {

    diff = 373 * scaleText;

    startingPosition =
      (opts.coordinates.startLeft * opts.canvasWidth) / 540 - diff;

    topPosition =
      (opts.coordinates.startTop * opts.canvasHeight) / 850;

    maxwidth = (380 * opts.canvasHeight) / 784;

    scaleText = scaleText * 0.85;
  }

  // =====================================================
  // TRINKET TRAYS (EXACT OLD LOGIC)
  // =====================================================
  if (opts.product_handle == "trinket-trays") {

    diff = 373 * scaleText;

    startingPosition =
      (opts.coordinates.startLeft * opts.canvasWidth) / 550 - diff;

    topPosition =
      (opts.coordinates.startTop * opts.canvasHeight) / 890;

    maxwidth = 250;
  }

  // =====================================================
  // POCKET POUCH (EXACT OLD LOGIC)
  // =====================================================
  if (opts.product_handle == "pocket-pouch") {

    diff = 373 * scaleText;

    startingPosition =
      (opts.coordinates.startLeft * opts.canvasWidth) / 550 - diff;

    topPosition =
      (opts.coordinates.startTop * opts.canvasHeight) / 890;

    maxwidth = 250;
  }

  // =====================================================
  // PASSPORT COVER (YOUR NEW LOGIC ONLY HERE)
  // =====================================================
  if (isPassport) {

    diff = 373 * scaleText;

    startingPosition =
      (opts.coordinates.startLeft * opts.canvasWidth) / 700;

    topPosition =
      (opts.coordinates.startTop * opts.canvasHeight) / 860;

    maxwidth = (400 * opts.canvasHeight) / 784;
  }

  // =====================================================
  // LUGGAGE TAG (YOUR NEW LOGIC ONLY HERE)
  // =====================================================
  if (isLuggage) {

    diff = 120 * scaleText;

    startingPosition =
      (opts.coordinates.startLeft * opts.canvasWidth) / 700 - diff;

    topPosition =
      (opts.coordinates.startTop * opts.canvasHeight) / 840;

    maxwidth = (250 * opts.canvasHeight) / 784;

    scaleText = scaleText * 0.85;
  }

  // =====================================================
  // TEXT WIDTH CONTROL (SAFE FOR ALL)
  // =====================================================
  if (totalWidth > maxwidth) {

    for (var i = 1; i < 50; i++) {
      opts.coordinates.scaleText =
        opts.coordinates.scaleText - i / 100;

      totalWidth = opts.totalWidthOfAlphabetText();

      if (totalWidth < maxwidth) break;
    }

    scaleText =
      (opts.coordinates.scaleText * opts.canvasWidth) / 608;

    if (isPassport) {
      startingPosition =
        (opts.coordinates.startLeft * opts.canvasWidth) / 700;
    }
    else if (isLuggage) {
      diff = 120 * scaleText;
      startingPosition =
        (opts.coordinates.startLeft * opts.canvasWidth) / 700 - diff;
    }
    else if (opts.product_handle == "trinket-trays") {
      diff = 373 * scaleText;
      startingPosition =
        (opts.coordinates.startLeft * opts.canvasWidth) / 550 - diff;
    }
    else if (opts.product_handle == "pocket-pouch") {
      diff = 373 * scaleText;
      startingPosition =
        (opts.coordinates.startLeft * opts.canvasWidth) / 550 - diff;
    }
    else {
      diff = 373 * scaleText;
      startingPosition =
        (opts.coordinates.startLeft * opts.canvasWidth) / 540 - diff;
    }
  }
}else {
        // console.log(opts.startLeft, opts.canvasWidth, requireSpace);
        var startingPosition = (opts.coordinates.startLeft * opts.canvasWidth) / 608 - requireSpace;
        if (opts.product_handle.includes("passport-cover")  ||  opts.product_handle.includes('luggage-tag') ) {
          startingPosition = startingPosition + 10
        }

        
  //           if (opts.product_handle.includes('luggage-tag')) {
  //   topPosition = (opts.coordinates.startTop * opts.canvasHeight) / 600;
  // }else{
  //   topPosition = (opts.coordinates.startTop * opts.canvasHeight) / 784;
  // }

         if (opts.product_handle.includes("pocket-pouch") ) {
     topPosition = (opts.coordinates.startTop * opts.canvasHeight) / 700;
  }
           if (opts.product_handle.includes("trinket-tray")) {
     topPosition = (opts.coordinates.startTop * opts.canvasHeight) / 760;
  }


        console.log("startingPosition1",startingPosition,topPosition,opts.coordinates.startLeft,requireSpace)
      }

      // --------  set angle for signature key chain start ---------
      if (opts.is_product_cat && opts.is_product_cat == "signature-keychain") {
        if ($(opts.inputField).val().length > 4) {
          return false;
        }
        angel = -90;
        startingPosition = 280;
        topPosition = 590;
      }
      if (
        opts.is_product_cat &&
        opts.is_product_cat == "top-right-position" &&
        textCharacters.length > 4
      ) {
        return false;
      }
      // -------- set angle for signature key chain end -----------

      fabric.Object.prototype.transparentCorners = false;

      // remove the existing custom fonts
      opts.removeExistingCustomFontText(
        opts.selectObject("alphabet_svg", "all")
      );

      if (opts.getSelectedLanguage() == "ar") {
        textCharacters = textCharacters.reverse();
      }
      // Add this AFTER your text rendering loop finishes
function addStaticLogos(canvasInstance) {
  // Check if logos already exist
     if (opts.product_handle.includes("pocket-pouch") || (opts.product_handle.includes("trinket-tray"))) return;
  //          if (opts.product_handle.includes("trinket-tray")) {
  //    topPosition = (opts.coordinates.startTop * opts.canvasHeight) / 760;
  // }


  const alreadyAdded = canvasInstance.getObjects().some(obj => obj.name === "static_logo");
  if (alreadyAdded) return; // ✅ Stop if they’re already added

  const staticImages = [
    {
      url: "https://cdn.shopify.com/s/files/1/0731/7871/0323/files/Toonz__logo_combined.png?v=1759843711",
left: opts.product_handle.includes("magsafe-wallet")
  ? opts.canvasWidth / 2.25
  : opts.product_handle.includes("passport-cover")
    ? opts.canvasWidth / 2.1
    : opts.product_handle.includes("luggage-tag")
      ? opts.canvasWidth / 2.2   // 👈 adjust if needed
      : opts.canvasWidth / 2.3,

top: opts.product_handle.includes("magsafe-wallet")
  ? opts.canvasHeight / 1.30
  : opts.product_handle.includes("passport-cover")
    ? opts.canvasHeight / 1.37
    : opts.product_handle.includes("luggage-tag")
      ? opts.canvasHeight / 1.28   // 👈 adjust vertical position here
      : opts.canvasHeight / 1.287,

      scale:  opts.product_handle.includes("magsafe-wallet")? opts.canvasWidth / 5500 : opts.canvasWidth / 5000,
    },
  ];


  staticImages.forEach((img) => {
    fabric.Image.fromURL(
      img.url,
      function (oImg) {
        oImg.set({
          left: img.left,
          top: img.top,
          scaleX: img.scale,
          scaleY: img.scale,
          selectable: false,
          evented: false,
          crossOrigin: "anonymous",
          name: "static_logo",
        });
        canvasInstance.add(oImg);
        canvasInstance.renderAll();
      },
      { crossOrigin: "Anonymous" }
    );
  });
}


      for (var i = 0; i < textCharacters.length; i++) {
        var char = textCharacters[i];
        var UpperLatter = char.toUpperCase()
        console.log("char3333",char)
         let imageData = lanejCustomAlphabet[UpperLatter][0];
         console.log("imageData",imageData)
        // imageData = opts.get3DTextImageData(
        //   "3d",
        //   opts.getSelectedLanguage(),
        //   opts.getSelected3DTextColor(),
        //   char
        // );
        var properties = {
          left: startingPosition,
          top: topPosition,
          scaleX: scaleText,
          scaleY: scaleText,
          selectable: false,
          evented: false,
          angle: angel,
          name: "alphabet_svg" + i.toString(),
          crossOrigin: "Anonymous",
        };
        console.log("new-properties",properties,imageData.url,)

        if (imageData.url) {
          $(opts.inputField).prop("disabled", true);

          fabric.Image.fromURL(
            imageData.url,
            function (oImg) {
              opts.canvasInstance.add(oImg);
              opts.rendered3DTextGroup.push(oImg);
              $(opts.inputField).prop("disabled", false);
              $(opts.inputField).focus();
            },
            properties
          );

          if (angel != 0) {
            topPosition = topPosition - imageData.width * scaleText - spacing;
          } else {
            startingPosition =
              startingPosition + imageData.width * scaleText + spacing;
          }
        }

        //console.log('startingPosition--loop  ', startingPosition);
      }
      addStaticLogos(opts.canvasInstance);
    },


// Helper function to remove previous alphabet stickers
removeAlphabetStickers: function() {
  if (!opts.canvasInstance) return;
  
  const objectsToRemove = [];
  opts.canvasInstance.getObjects().forEach(function(obj) {
    if (obj.name && obj.name.startsWith('alphabet_sticker')) {
      objectsToRemove.push(obj);
    }
  });
  
  objectsToRemove.forEach(function(obj) {
    opts.canvasInstance.remove(obj);
  });
}
,



    removeExistingCustomFontText: function (canvasInstances) {
      if (canvasInstances.length > 0) {
        for (let i = 0; i < canvasInstances.length; i++) {
          opts.canvasInstance.remove(canvasInstances[i]);
        }
      }
    },

    createGradient: function (colors, angle = 45) {
      // Convert angle to coordinates
      const angleRad = (angle * Math.PI) / 180;
      const x2 = Math.cos(angleRad) * 100;
      const y2 = Math.sin(angleRad) * 100;

      return new fabric.Gradient({
        type: "linear",
        coords: {
          x1: 0,
          y1: 0,
          x2: x2,
          y2: y2,
        },
        colorStops: colors.map((color, index) => ({
          offset: index / (colors.length - 1),
          color: color,
        })),
      });
    },

    changeCanvasTextObject: function (type) {
      let properties = {};

      let gradiantColor = opts.getSelectedTextGradiantColor();
      console.log("gradiantColor", gradiantColor);

      if (type === "textColor") {
        if (gradiantColor != "undefined") {
          const gradientStr = gradiantColor;

          const regex = /linear-gradient\(([^,]+),\s*([^,]+),\s*([^)]+)\)/;
          const match = gradientStr.match(regex);

          if (match) {
            const angleDeg = match[1].trim() ? match[1].trim() : "90deg"; // "45deg"
            const angle = parseInt(angleDeg, 10);

            const color1 = match[2].trim() ? match[2].trim() : "#ffffff"; // "#ff9a9e"
            const color2 = match[3].trim() ? match[3].trim() : "#ff0000"; // "#fad0c4"
            console.log({ angle, color1, color2 });
            properties["fill"] = this.createGradient([color1, color2], angle);
          }
        } else {
          properties["fill"] = opts.getSelectedTextColorStrokeFill()
            ? opts.getSelectedTextColorStrokeFill()
            : opts.getSelectedTextColor();
        }
        properties["shadow"] = opts.getSelectedTextColorShadow();
        properties["stroke"] = opts.getSelectedTextColorSroke();
        properties["strokeWidth"] = opts.getSelectedTextColorStrokeWidth();
      } else if (type === "fontFamily") {
        properties["fontFamily"] = opts.getSelectedFontFamily();
        properties["left"] = opts.coordinates.startLeft;
        properties["top"] = opts.coordinates.startTop;
        properties["fontSize"] = opts.coordinates.fontSize;
        properties["angle"] = opts.coordinates.anglePosition;
        if (gradiantColor != "undefined") {
          const gradientStr = gradiantColor;

          const regex = /linear-gradient\(([^,]+),\s*([^,]+),\s*([^)]+)\)/;
          const match = gradientStr.match(regex);

          if (match) {
            const angleDeg = match[1].trim() ? match[1].trim() : "90deg"; // "45deg"
            const angle = parseInt(angleDeg, 10);

            const color1 = match[2].trim() ? match[2].trim() : "#ffffff"; // "#ff9a9e"
            const color2 = match[3].trim() ? match[3].trim() : "#ff0000"; // "#fad0c4"
            console.log({ angle, color1, color2 });
            properties["fill"] = this.createGradient([color1, color2], angle);
          }
        } else {
          properties["fill"] = opts.getSelectedTextColor();
        }
        properties["fontWeight"] =
          opts.fontTypes[opts.getSelectedFontFamily()]["weight"];
      } else if (type === "customTextColor") {
        opts.specialFontsSetCoordinates(); // re-render 3d text of selected color
      }
      console.log(properties);
      if (
        opts.selectObject("normal-font", "first") != undefined &&
        type != "customTextColor"
      ) {
        opts.selectObject("normal-font", "first").setOptions(properties);
        opts.canvasInstance.renderAll();
        /* if(window.opts.canvasInstance.toDataURL()){
        alert("updated");
        $('#image_raw_content').val(window.opts.canvasInstance.toDataURL());
      }
      else{
        alert("not updated");
      }*/
      }
    },

    renderNormalTextOnCanvas: function (val) {
       // Check if font family is Script and value contains lowercase letters
      let adjustedFontSize = opts.coordinates.fontSize;
      if (opts.getSelectedFontFamily() === 'Script' && val.match(/[a-z]/) && opts.getSelectedTextPosition() == 'right-bottom') {
        adjustedFontSize = (160 * opts.canvasWidth) / 608;
      }
      
      if (Object.keys(opts.canvasTextInstance).length == 0) {
        let textProperties = {
          width: 200,
          selectable: false,
          fontFamily: opts.getSelectedFontFamily(),
          fontWeight: opts.fontTypes[opts.getSelectedFontFamily()]["weight"],
          left: opts.coordinates.startLeft,
          top: opts.coordinates.startTop,
          fontSize: opts.coordinates.fontSize,
          textAlign: "center",
          angle: opts.coordinates.anglePosition,
          // gradiant: opts.getSelectedTextGradiantColor(),
          fill: opts.getSelectedTextColorStrokeFill()
            ? opts.getSelectedTextColorStrokeFill()
            : opts.getSelectedTextColor(),
          name: "normal-font",
          shadow: opts.getSelectedTextColorShadow(),
          stroke: opts.getSelectedTextColorSroke(),
          strokeWidth: opts.getSelectedTextColorStrokeWidth(),
        };
        console.log(textProperties);

        opts.canvasTextInstance = new fabric.Text(val, textProperties);
        opts.canvasTextInstance.selectable = false;

        opts.canvasInstance.add(opts.canvasTextInstance);
        return;
      }

      let selectedObject = opts.selectObject("normal-font", "first");
      selectedObject.set("text", val);

      // if(product_cat){

      //   var $this = $('#sf-canvas');
      //   let textLength = $(opts.inputField).val().length;
      //   if(product_cat == 'signature-holder'){
      //       opts.coordinates.startLeft = textLength > 0 ? 285 - (textLength * 10) :  285 ,
      //       textProperties.left = textLength > 0 ? 285 - (textLength * 10) :  285,
      //       textProperties.top = 470,
      //       textProperties.fontSize = 50;
      //       textProperties.fill = opts.getSelectedTextColor() ? opts.getSelectedTextColor() : '#000';
      //   }

      //   if(opts.getSelectedFontFamily() == 'LaLuxesScript'){
      //       textProperties.fontSize = 70;
      //       opts.coordinates.scaleText = 2;
      //   }
      //   console.log(opts.getSelectedFontFamily())
      // }
      let gradiantColor = opts.getSelectedTextGradiantColor();
      if (gradiantColor != "undefined") {
        const gradientStr = gradiantColor;

        const regex = /linear-gradient\(([^,]+),\s*([^,]+),\s*([^)]+)\)/;
        const match = gradientStr.match(regex);
        var color1 = "#ffffff"; // "#ff9a9e"
        var color2 = "#ff0000"; // "#fad0c4"
        var angle = "90deg";

        if (match) {
          const angleDeg = match[1].trim() ? match[1].trim() : "90deg"; // "45deg"
          angle = parseInt(angleDeg, 10);

          color1 = match[2].trim() ? match[2].trim() : "#ffffff"; // "#ff9a9e"
          color2 = match[3].trim() ? match[3].trim() : "#ff0000"; // "#fad0c4"
        }
        selectedObject.setOptions({
          left: opts.coordinates.startLeft,
          top: opts.coordinates.startTop,
          fontSize: opts.coordinates.fontSize,
          angle: opts.coordinates.anglePosition,
          gradiant: opts.getSelectedTextGradiantColor(),
          fill: this.createGradient([color1, color2], angle),
          selectable: false,
        });
      } else {
        selectedObject.setOptions({
          left: opts.coordinates.startLeft,
          top: opts.coordinates.startTop,
          fontSize: opts.coordinates.fontSize,
          angle: opts.coordinates.anglePosition,
          gradiant: opts.getSelectedTextGradiantColor(),
          fill: opts.getSelectedTextColor(),
          selectable: false,
        });
      }

      opts.canvasInstance.renderAll();
    },

    setInputLimitBaseOnFontType: function (fontFamily) {
      let input = $(opts.inputField),
        fontLimit = opts.fontTypes[fontFamily]["limit"];

      input.attr("maxlength", fontLimit);
      input.val(input.val().substring(0, fontLimit)).trigger("keyup");
    },
  };

  var getImageUrl = function () {
    console.log(
      opts.getMediaEle().find(".swiper-container").length,
      "getttt111"
    );
    console.log(
      opts
        .getMediaEle()
        .find(".swiper-wrapper .swiper-slide-active img")
        .attr("src")
    );
    console.log(
      opts
        .getMediaEle()
        .find(".swiper-wrapper .swiper-slide:eq(0) img.f-img-loaded")
        .attr("src")
    );
    if (opts.getMediaEle().find(".swiper-container").length > 0) {
      return opts
        .getMediaEle()
        .find(".swiper-wrapper .swiper-slide-active img")
        .attr("src");
    } else {
      return opts
        .getMediaEle()
        .find(".swiper-wrapper .swiper-slide:eq(0) img.f-img-loaded")
        .attr("src");
    }
  };

var setCoordinates = function (selectedFont) {
    console.log("selectedFont", selectedFont);

    var textChar = $('input[name="initial"]').val()?.length;
    if (selectedFont == 'toonzAlphabet') {
        textChar = $('input[name="alphabet-sticker"]').val()?.length;
    }
    console.log(opts.getSelectedToonzAlphabetPosition(), "opts.is_product_cat",opts.is_product_cat);

    // ✅ Choose which position function to use
    var selectedPosition = (selectedFont == 'toonzAlphabet')
        ? opts.getSelectedToonzAlphabetPosition()
        : opts.getSelectedTextPosition();

    // ✅ Font size logic
    if (selectedPosition == "center-small" || selectedPosition == "center-bottom-small") {
        opts.coordinates.fontSize = (80 * opts.canvasWidth) / 608;
    } else if (selectedPosition == "right-bottom") {
        opts.coordinates.fontSize = (120 * opts.canvasWidth) / 608;
    } else {
        opts.coordinates.fontSize = (100 * opts.canvasWidth) / 608;
    }

    switch (selectedPosition) {
        case "center":
            opts.coordinates.startTop = 338;
            opts.coordinates.startLeft = 308; // Default value
            opts.coordinates.scaleText = 0.5 + 0.1 * (textChar - 1);
            opts.coordinates.scaleText = opts.coordinates.scaleText / (textChar * 0.9);
            opts.coordinates.anglePosition = 0;
            opts.coordinates.charsLimit = 7;

            // collections lanejCustomizer code start ------
            console.log(opts.is_product_cat);
            if (opts.is_product_cat) {
                opts.coordinates.startTop = 430;
                opts.coordinates.scaleText = 0.59;
                opts.coordinates.charsLimit = 7;

                if (opts.is_product_cat == "font-customizable") {
                    opts.coordinates.startTop = 338;
                    opts.coordinates.scaleText = 0.4;
                    opts.coordinates.charsLimit = 7;
                    opts.coordinates.scaleText = 0.5 + 0.1 * (textChar - 1);
                    opts.coordinates.scaleText = opts.coordinates.scaleText / (textChar * 0.9);
                }

                if (opts.is_product_cat == "grande-card-holder") {
                    opts.coordinates.startTop = 514;
                }

                if (opts.is_product_cat == "signature-holder") {
                    opts.coordinates.startTop = 420;
                }

                if (opts.is_product_cat == "top-right-position") {
                    opts.coordinates.startTop = 140;
                    opts.coordinates.startLeft = 385;
                    opts.coordinates.charsLimit = 3;
                }

                if (opts.is_product_cat == "bi-fold-holder") {
                    opts.coordinates.startTop = 540;
                    opts.coordinates.startLeft = 434;
                    let charecters = $(opts.inputField).val();
                    let color = opts.getSelectedColor();
                    let minusLeft = 0;
                    for (let i = 0; i < charecters.length; i++) {
                        if (opts.getSelectedLanguage() == "en") {
                            minusLeft += lanejCustomFonts2["3d"][opts.getSelectedLanguage()][color][charecters[i]]["width"] / 2 - 2;
                        } else {
                            minusLeft += 40 / 2 - 2;
                        }
                    }
                    opts.coordinates.startLeft = opts.coordinates.startLeft - minusLeft;
                }

                $(opts.inputField).attr("maxlength", opts.coordinates.charsLimit);
            }

            // ✅ Ensure sticker-print overrides
            if (opts.is_sticker_print || opts.product_type === 'sticker' || opts.is_product_cat === 'sticker-print') {
                opts.coordinates.startLeft = 250;
                console.log("Sticker print detected, setting startLeft to 250");
            }
            break;

        case "vertical-center":
          if (opts.product_handle == "trinket-trays") {
            console.log("gettthererer")
              opts.coordinates.startTop = 200;
            opts.coordinates.startLeft = 268;
            opts.coordinates.scaleText = 0.3 - 0.05 * textChar;
            opts.coordinates.anglePosition = -90;
          }
            opts.coordinates.startTop = 460;
            opts.coordinates.startLeft = 268;
            opts.coordinates.scaleText = 0.54 - 0.05 * textChar;
            opts.coordinates.anglePosition = -90;
            break;

        case "right-bottom":
            opts.coordinates.scaleText = 0.54 - 0.05 * textChar;
            opts.coordinates.startTop = 662;
            opts.coordinates.startLeft = 430;
            opts.coordinates.anglePosition = -90;
            opts.coordinates.fontSize = (120 * opts.canvasWidth) / 608;
            break;

        case "center-bottom-small":
            opts.coordinates.startTop = 600;
            opts.coordinates.startLeft = 312;
            opts.coordinates.scaleText = 0.21;
            opts.coordinates.anglePosition = 0;
            break;

        case "center-small":
            opts.coordinates.startTop = 338;
            opts.coordinates.startLeft = 312;
            opts.coordinates.scaleText = 0.21;
            opts.coordinates.anglePosition = 0;
            break;

        case "top-right":
            opts.coordinates.startTop = 140;
            opts.coordinates.startLeft = 385;
            opts.coordinates.charsLimit = 3;
            break;
    }
};


  var createCanvas = function () {
    opts.canvasInstance = window._canvas = new fabric.Canvas(
      opts.canvasSelector,
      {
        selection: false,
        controlsAboveOverlay: true,
        centeredScaling: true,
        allowTouchScrolling: true,
        direction: "ltr",
      }
    );
    updateCanvasSize();

    applyFontStylesOnLabels();
    opts.renderColorsList();
    opts.build3DColorsList();

    // active font type on element
    opts.applyFontOnHelperElement();

    $(".canvas-container canvas").show();

    switchProductImage();

    if (window.opts.is_brx_prod == true) {
      $("#font_style_baskerville10Pro").click();
    } else {
      $("#font_style_customFont").click();
    }
  };

  var updateCanvasSize = function () {
    opts.canvasWidth = opts.getMediaEle().width();
    opts.canvasHeight = opts.getMediaEle().height();
    $("#" + opts.canvasWrapper).height(opts.canvasHeight);
    opts.canvasInstance.setWidth(opts.canvasWidth);
    opts.canvasInstance.setHeight(opts.canvasHeight);
    opts.canvasInstance.on("after:render", function () {
      // call the save function here
      //$('#image_raw_content').val(window.opts.canvasInstance.toDataURL());
      // alert('rendered');
    });
  };

  var switchProductImage = function () {
    setProductImage();
  };

  var applyFontStylesOnLabels = function () {
    $('[data-option-type="fontFamily"] .variant-picker__input').each(
      function () {
        let fontType = $(this).find("input").data("option-value");
        console.log(
          opts.fontTypes[fontType]
            ? opts.fontTypes[fontType]["weight"]
            : "inherit"
        );
        $(this)
          .find("label")
          .css({
            fontFamily: fontType,
            fontWeight: opts.fontTypes[fontType]
              ? opts.fontTypes[fontType]["weight"]
              : "inherit",
          });
      }
    );
  };

  var setProductImage = function (link) {
    let imgSrc = typeof link != "undefined" ? link : getImageUrl();
    console.log(imgSrc, "GetttimgSrc");
    fabric.Image.fromURL(
      imgSrc,
      function (img) {
        var canvasAspect = opts.canvasWidth / opts.canvasHeight;
        var imgAspect = img.width / img.height;
        var imgPositionLeft, imgPositionTop, canvasScale;
        if (canvasAspect >= imgAspect) {
          var canvasScale = opts.canvasWidth / img.width;
          imgPositionLeft = 0;
          imgPositionTop = -(img.height * canvasScale - opts.canvasHeight) / 2;
        } else {
          var canvasScale = opts.canvasHeight / img.height;
          imgPositionTop = 0;
          imgPositionLeft = -(img.width * canvasScale - opts.canvasWidth) / 2;
        }
        img.set({
          top: imgPositionTop,
          left: imgPositionLeft,
          originX: "left",
          originY: "top",
          scaleX: canvasScale,
          scaleY: canvasScale,
        });
        opts.canvasInstance.setBackgroundImage(
          img,
          opts.canvasInstance.renderAll.bind(opts.canvasInstance)
        );
      },
      {
        /* crossOrigin: 'Anonymous'*/
      }
    );


// setTimeout(function () {
//   const label = document.querySelector('label[for="lanej_customization_font"]');
//   console.log("label",label)
  
//   if (label) {
//     label.click();
//   }
// }, 2000);


    // $('#canvasActivor').click();
  };

  // event handlers

  // Sticker Customization - Start ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  console.log("Sticker customization Start");

let selectedAlphabets = [];

  $(opts.getToonzStickerMediaEle).on(
    "click",
    ".sticker-image-container",
    function (e) {
      console.log("ge111")
      $(".sticker-image-container").removeClass("selected");
      $(this).addClass("selected");
      opts.canvasInstance.getObjects("image").forEach(function (obj) {
        opts.canvasInstance.remove(obj);
      });
      handleToonzStickerSelection(this);
    }
  );

  function handleToonzStickerSelection() {
    // console.log( $(opts.selectCaseSizeField).find('option:selected').val(),"selectCaseSizeField")
    let caseSize = $(opts.selectCaseSizeField).find("option:selected").val();
    console.log("caseSize", caseSize);
    let productTitle = opts.productTitle.text();
    let stickerElement = $(".sticker-image-container.selected");
    var SelectedPosition = $(stickerElement).find("img").attr("alt");
    console.log("stickerElement",stickerElement,SelectedPosition)

    console.log("opts.canvasWidth",opts.canvasWidth)

    let selectedImages = [];
    let caseType;
    if (
      (productTitle == "Pebbled Vegan Leather Magsafe Wallet" ||
        productTitle == "Faux Croc Leather Magsafe Wallet" ||
        productTitle.includes("Wallet") ||
        productTitle == "Nappa Vegan Leather Magsafe Wallet") &&
      opts.canvasWidth == "615"
    ) {
      caseType = "magsafeDesktopStickers";
    }
    else if (
       productTitle.includes("Passport Cover") && opts.canvasWidth == "615"
    ) {
      caseType = "passportDesktopStickers";
    }
    else if (
       productTitle.includes("Passport Cover")
    ) {
      caseType = "passportMobileStickers";
    }  

    else if (
      productTitle == "Pebbled Vegan Leather Magsafe Wallet" ||
      productTitle == "Faux Croc Leather Magsafe Wallet" ||
      productTitle.includes("Wallet") ||
      productTitle == "Nappa Vegan Leather Magsafe Wallet"
    ) {
      caseType = "magsafeMobileStickers";
    } 
    
   else if (productTitle.includes("Pocket Pouch") && opts.canvasWidth < 615) {
      caseType = "mobilePocketPouch";
    } 
       else if ( productTitle.includes("Trinket Tray") && opts.canvasWidth < 615) {
      caseType = "mobileTrinketTray";
    } 

    else if (
      productTitle.includes("Pocket Pouch")  
     
    ) {
      caseType = "pocketPouch";
    } 
          else if (

      productTitle.includes("Trinket Tray") 
    ) {
      caseType = "trinketTray";
    }
              else if (

      productTitle.includes("Luggage Tag") && opts.canvasWidth < 615
    ) {
      caseType = "mobileLuggageTag";
    }
          else if (

      productTitle.includes("Luggage Tag") 
    ) {
      caseType = "luggageTag";
    }
     else if (
      (productTitle ==
        "Signature Saffiano Leather iPhone case with Black Border" ||
        productTitle ==
          "Signature Pebbled Leather iPhone Case with Black Border") &&
      opts.canvasWidth == "615"
    ) {
      caseType = "SignatureDesktopSize";
    } else if (
      productTitle ==
        "Signature Saffiano Leather iPhone case with Black Border" ||
      productTitle == "Signature Pebbled Leather iPhone Case with Black Border"
    ) {
      caseType = "SignatureMobileSize";
    }  
    
    else if (
      (caseSize == "iPhone 7/8" ||
        caseSize == "iPhone 7/ 8" ||
        caseSize == "iPhone 7+/8+" ||
        caseSize == "iPhone X/XS" ||
        caseSize == "iPhone XS Max" ||
        caseSize == "iPhone XR" ||
        caseSize == "iPhone 7+/ 7S+") &&
      opts.canvasWidth == "615"
    ) {
      caseType = "OldPhoneDesktopSize";
    } else if (
      caseSize == "iPhone 7/8" ||
      caseSize == "iPhone 7/ 8" ||
      caseSize == "iPhone 7+/8+" ||
      caseSize == "iPhone X/XS" ||
      caseSize == "iPhone XS Max" ||
      caseSize == "iPhone XR" ||
      caseSize == "iPhone 7+/ 7S+"
    ) {
      caseType = "OldPhoneMobileSize";
    }  else if (
      (caseSize == "iPhone 7/8" ||
        caseSize == "iPhone 7/ 8" ||
        caseSize == "iPhone 7+/8+" ||
        caseSize == "iPhone X/XS" ||
        caseSize == "iPhone XS Max" ||
        caseSize == "iPhone XR" ||
        caseSize == "iPhone 7+/ 7S+") &&
      opts.canvasWidth == "615"
    ) {
      caseType = "OldPhoneDesktopSize";
    } else if (opts.canvasWidth == "615") {
      caseType = "DesktopSize";
    } else {
      caseType = "MobileSize";
    }
console.log("caseType:", caseType);
console.log("SelectedPosition:", SelectedPosition);
console.log("lanejToonzSticker[caseType]:", lanejToonzSticker[caseType]);

    if (lanejToonzSticker[caseType][SelectedPosition]) {
      selectedImages = lanejToonzSticker[caseType][SelectedPosition];
    } else {
      console.log("Invalid position");
    }

    drawImagesInOrder(selectedImages, opts);

    // Function to load image and add it to the canvas
    function addImageToCanvas(url, properties, width, height) {
      return new Promise((resolve, reject) => {
        fabric.Image.fromURL(
          url,
          function (oImg) {
            oImg.set(properties);
            oImg.scaleToWidth(width);
            oImg.scaleToHeight(height);
            opts.canvasInstance.add(oImg);
            resolve();
          },
          { crossOrigin: "Anonymous" }
        );
      });
    }

    // Function to process and draw images in sequence
    async function drawImagesInOrder(selectedImages, opts) {
      for (let img of selectedImages) {
        let adjustedLeft = img.left;
        let adjustedWidth = img.width;
        let adjustedHeight = img.height;
        let adjustedTop = img.top;

        let properties = {
          left: adjustedLeft * opts.canvasWidth,
          top: adjustedTop * opts.canvasHeight,
          originX: "left",
          originY: "top",
    
          angle: img.angle,
        };

        await addImageToCanvas(
          img.url,
          properties,
          adjustedWidth * opts.canvasWidth,
          adjustedHeight * opts.canvasHeight
        );
      }
    }
  }


  $(opts.getStickerMediaEle).on(
    "click",
    ".sticker-image-container",
    function (e) {
      console.log("ge111")
      $(".sticker-image-container").removeClass("selected");
      $(this).addClass("selected");
      opts.canvasInstance.getObjects("image").forEach(function (obj) {
        opts.canvasInstance.remove(obj);
      });
      handleStickerSelection(this);
    }
  );

  function handleStickerSelection() {
    // console.log( $(opts.selectCaseSizeField).find('option:selected').val(),"selectCaseSizeField")
    let caseSize = $(opts.selectCaseSizeField).find("option:selected").val();
    console.log("caseSize", caseSize);
    let productTitle = opts.productTitle.text();
    let stickerElement = $(".sticker-image-container.selected");
    var SelectedPosition = $(stickerElement).find("img").attr("alt");

    let selectedImages = [];
    let caseType;
    if (
      (productTitle == "Pebbled Vegan Leather Magsafe Wallet" ||
        productTitle == "Faux Croc Leather Magsafe Wallet" ||
        productTitle.includes("Wallet") ||
        productTitle == "Nappa Vegan Leather Magsafe Wallet") &&
      opts.canvasWidth == "615"
    ) {
      caseType = "magsafeDesktopStickers";
    } else if (
      productTitle == "Pebbled Vegan Leather Magsafe Wallet" ||
      productTitle == "Faux Croc Leather Magsafe Wallet" ||
      productTitle == "Nappa Vegan Leather Magsafe Wallet"||
      productTitle.includes("Wallet") 
    ) {
      caseType = "magsafeMobileStickers";
    } else if (
      (caseSize == "iPhone 7/8" ||
        caseSize == "iPhone 7/ 8" ||
        caseSize == "iPhone 7+/8+" ||
        caseSize == "iPhone X/XS" ||
        caseSize == "iPhone XS Max" ||
        caseSize == "iPhone XR" ||
        caseSize == "iPhone 7+/ 7S+") &&
      opts.canvasWidth == "615"
    ) {
      caseType = "OldPhoneDesktopSize";
    } else if (
      caseSize == "iPhone 7/8" ||
      caseSize == "iPhone 7/ 8" ||
      caseSize == "iPhone 7+/8+" ||
      caseSize == "iPhone X/XS" ||
      caseSize == "iPhone XS Max" ||
      caseSize == "iPhone XR" ||
      caseSize == "iPhone 7+/ 7S+"
    ) {
      caseType = "OldPhoneMobileSize";
    } else if (
      (productTitle ==
        "Signature Saffiano Leather iPhone case with Black Border" ||
        productTitle ==
          "Signature Pebbled Leather iPhone Case with Black Border") &&
      opts.canvasWidth == "615"
    ) {
      caseType = "SignatureDesktopSize";
    } else if (
      productTitle ==
        "Signature Saffiano Leather iPhone case with Black Border" ||
      productTitle == "Signature Pebbled Leather iPhone Case with Black Border"
    ) {
      caseType = "SignatureMobileSize";
    } else if (
      (caseSize == "iPhone 7/8" ||
        caseSize == "iPhone 7/ 8" ||
        caseSize == "iPhone 7+/8+" ||
        caseSize == "iPhone X/XS" ||
        caseSize == "iPhone XS Max" ||
        caseSize == "iPhone XR" ||
        caseSize == "iPhone 7+/ 7S+") &&
      opts.canvasWidth == "615"
    ) {
      caseType = "OldPhoneDesktopSize";
    } else if (opts.canvasWidth == "615") {
      caseType = "DesktopSize";
    } else {
      caseType = "MobileSize";
    }

    if (lanejCustomSticker[caseType][SelectedPosition]) {
      selectedImages = lanejCustomSticker[caseType][SelectedPosition];
    } else {
      console.log("Invalid position");
    }

    drawImagesInOrder(selectedImages, opts);

    // Function to load image and add it to the canvas
    function addImageToCanvas(url, properties, width, height) {
      return new Promise((resolve, reject) => {
        fabric.Image.fromURL(
          url,
          function (oImg) {
            oImg.set(properties);
            oImg.scaleToWidth(width);
            oImg.scaleToHeight(height);
            opts.canvasInstance.add(oImg);
            resolve();
          },
          { crossOrigin: "Anonymous" }
        );
      });
    }

    // Function to process and draw images in sequence
    async function drawImagesInOrder(selectedImages, opts) {
      for (let img of selectedImages) {
        let adjustedLeft = img.left;
        let adjustedWidth = img.width;
        let adjustedHeight = img.height;
        let adjustedTop = img.top;

        let properties = {
          left: adjustedLeft * opts.canvasWidth,
          top: adjustedTop * opts.canvasHeight,
          originX: "left",
          originY: "top",
    
          angle: img.angle,
        };

        await addImageToCanvas(
          img.url,
          properties,
          adjustedWidth * opts.canvasWidth,
          adjustedHeight * opts.canvasHeight
        );
      }
    }
  }
    // Initialize this once (when canvas loads or product changes)
opts.nextLetterLeft = opts.coordinates.startLeft;

  $(opts.selectCaseSizeField).on("change", function (e) {
    handleStickerSelection(this);
    opts.canvasInstance.getObjects("image").forEach(function (obj) {
      opts.canvasInstance.remove(obj);
    });
  });

  console.log("Sticker customization End");
  // Sticker Customization - End ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  $(opts.inputField).on("keyup", function (e) {
    // CC- Code for disable type if language is Arabic - START
    var maxCharLimit = $(this).attr("maxlength");

    // Ensure we capture the latest value of the input field
    let ele = $(this),
      val = ele.val(), // Capture the value after the keyup event
      inputParent = ele.closest(".variant-picker__input");
    console.log("ele", ele.val());

    console.log(
      $(this).val().length > maxCharLimit,
      $(this).val().length,
      maxCharLimit
    );

    if (opts.getSelectedLanguage() == "ar" && val.length > maxCharLimit) {
      return false;
    }
    // CC- Code for disable type if language is Arabic - END

    console.log(
      "opts.restrictToDrawOnCanvas()::::",
      opts.restrictToDrawOnCanvas()
    );
    if (!opts.restrictToDrawOnCanvas()) {
      opts.removeExistingCustomFontText(
        opts.selectObject("alphabet_svg", "all")
      );
      ele.val(""); // Clear the input field
      return false;
    }
    //  let ele = $(this),
    //   val = ele.val(),
    //   inputParent = ele.closest(".variant-picker__input");

    let fontFamily = opts.getSelectedFontFamily();
    if (fontFamily == 'Monotype') {
      val = val.toUpperCase();
    console.log("Fonttttt", fontFamily)
    }

    console.log("valllll", val);

    // Restrict input characters based on language
    if (val.match(/[^a-zA-Z0-9♥♡.!&]/g) && opts.getSelectedLanguage() != "ar") {
      ele.val(val.replace(/[^a-zA-Z0-9♥♡.!&]/g, ""));
      return;
    }

    inputParent.find(".selected-value").html(val);
    $(opts.fontElementHelper).html(val);

    opts.setCoordinatesBasedOnFont(opts.getSelectedFontFamily());

    if (opts.getSelectedFontFamily() !== "customFont") {
      opts.renderNormalTextOnCanvas(val);
    }
    // else {
    //   opts.render3DTextOnCanvas(val);
    // }
  });

    $(opts.alphabetInputField).on("keyup", function (e) {
    // CC- Code for disable type if language is Arabic - START
    var maxCharLimit = $(this).attr("maxlength");

    // Ensure we capture the latest value of the input field
    let ele = $(this),
      val = ele.val(), // Capture the value after the keyup event
      inputParent = ele.closest(".variant-picker__input");
    console.log("ele", ele.val());

    console.log(
      $(this).val().length > maxCharLimit,
      $(this).val().length,
      maxCharLimit
    );

    if (opts.getSelectedLanguage() == "ar" && val.length > maxCharLimit) {
      return false;
    }
    // CC- Code for disable type if language is Arabic - END
    console.log("valllll", val);

    // Restrict input characters based on language
    if (val.match(/[^a-zA-Z0-9♥♡.!&]/g) && opts.getSelectedLanguage() != "ar") {
      ele.val(val.replace(/[^a-zA-Z0-9♥♡.!&]/g, ""));
      return;
    }

    inputParent.find(".selected-value").html(val);
    $(opts.fontElementHelper).html(val);

    opts.setCoordinatesBasedOnFont('toonzAlphabet');

  });

  $(opts.inputField).on("input", function (e) {
    console.log(" opts.coordinates.fontSize", opts.coordinates.fontSize)
    opts.coordinates.fontSize = 200;
    if (
      (window.opts.getSelectedFontFamily() == "Baskerville10Pro" &&
      this.value) || window.opts.getSelectedFontFamily() == "Monotype"
    ) {
      this.value = this.value.toUpperCase();
      // val = val.toUpperCase();
    }
  });

  $(opts.inputFontPosition).on("click", function (e) {
    // if (!opts.restrictToDrawOnCanvas()) {
    //   return false;
    // }
    console.log("opts.getSelectedFontFamily()",opts.getSelectedFontFamily())

    opts.setCoordinatesBasedOnFont(opts.getSelectedFontFamily());
    console.log("opts.coordinates.fontSize", opts.coordinates.fontSize);

    let gradiantColor = opts.getSelectedTextGradiantColor();
    if (gradiantColor != "undefined") {
      const gradientStr = gradiantColor;

      const regex = /linear-gradient\(([^,]+),\s*([^,]+),\s*([^)]+)\)/;
      const match = gradientStr.match(regex);
      var color1 = "#ffffff"; // "#ff9a9e"
      var color2 = "#ff0000"; // "#fad0c4"
      var angle = "90deg";

      if (match) {
        const angleDeg = match[1].trim() ? match[1].trim() : "90deg"; // "45deg"
        angle = parseInt(angleDeg, 10);

        color1 = match[2].trim() ? match[2].trim() : "#ffffff"; // "#ff9a9e"
        color2 = match[3].trim() ? match[3].trim() : "#ff0000"; // "#fad0c4"
      }
      opts.selectObject("normal-font", "first").setOptions({
        left: opts.coordinates.startLeft,
        top: opts.coordinates.startTop,
        fontSize: opts.coordinates.fontSize,
        textAlign: "center",
        angle: opts.coordinates.anglePosition,
        fill: opts.createGradient([color1, color2], angle),
      });
    } else {
      opts.selectObject("normal-font", "first").setOptions({
        left: opts.coordinates.startLeft,
        top: opts.coordinates.startTop,
        fontSize: opts.coordinates.fontSize,
        textAlign: "center",
        angle: opts.coordinates.anglePosition,
        fill: opts.getSelectedTextColor(),
      });
    }

    opts.canvasInstance.renderAll();
    /*   if(window.opts.canvasInstance.toDataURL()){
        alert("updated");
        $('#image_raw_content').val(window.opts.canvasInstance.toDataURL());
      }
      else{
        alert("not updated");
      }*/
  });
  
  $(opts.toonzAlphabetPosition).on("click", function (e) {
    // if (!opts.restrictToDrawOnCanvas()) {
    //   return false;
    // }


    opts.setCoordinatesBasedOnFont('toonzAlphabet');
    console.log("opts.coordinates.fontSize", opts.coordinates.fontSize);

    // let gradiantColor = opts.getSelectedTextGradiantColor();
    // if (gradiantColor != "undefined") {
    //   const gradientStr = gradiantColor;

    //   const regex = /linear-gradient\(([^,]+),\s*([^,]+),\s*([^)]+)\)/;
    //   const match = gradientStr.match(regex);
    //   var color1 = "#ffffff"; // "#ff9a9e"
    //   var color2 = "#ff0000"; // "#fad0c4"
    //   var angle = "90deg";

    //   if (match) {
    //     const angleDeg = match[1].trim() ? match[1].trim() : "90deg"; // "45deg"
    //     angle = parseInt(angleDeg, 10);

    //     color1 = match[2].trim() ? match[2].trim() : "#ffffff"; // "#ff9a9e"
    //     color2 = match[3].trim() ? match[3].trim() : "#ff0000"; // "#fad0c4"
    //   }
    //   opts.selectObject("normal-font", "first").setOptions({
    //     left: opts.coordinates.startLeft,
    //     top: opts.coordinates.startTop,
    //     fontSize: opts.coordinates.fontSize,
    //     textAlign: "center",
    //     angle: opts.coordinates.anglePosition,
    //     fill: opts.createGradient([color1, color2], angle),
    //   });
    // } else {
    //   opts.selectObject("normal-font", "first").setOptions({
    //     left: opts.coordinates.startLeft,
    //     top: opts.coordinates.startTop,
    //     fontSize: opts.coordinates.fontSize,
    //     textAlign: "center",
    //     angle: opts.coordinates.anglePosition,
    //     fill: opts.getSelectedTextColor(),
    //   });
    // }

    opts.canvasInstance.renderAll();
    /*   if(window.opts.canvasInstance.toDataURL()){
        alert("updated");
        $('#image_raw_content').val(window.opts.canvasInstance.toDataURL());
      }
      else{
        alert("not updated");
      }*/
  });

  // STICKER CUSTOMIZATION - START +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  console.log("Sticker Customization");

  $(opts.customizationSelector).on("change", function (e) {
    // $('.stickers-main-div .sticker-image-container').each(function() {
    //     $(this).removeClass('selected');
    // });

    //   opts.canvasInstance.getObjects('image').forEach(function(obj) {
    //     opts.canvasInstance.remove(obj);
    //   });

    $(".stickers-main-div .sticker-image-container").each(function () {
      $(this).removeClass("selected");
    });

    opts.canvasInstance.getObjects().forEach(function (obj) {
      opts.canvasInstance.remove(obj);
    });
    Object.keys(opts.canvasTextInstance).forEach((key) => {
      delete opts.canvasTextInstance[key];
    });

    $(".customizeSelector").find(".active-radio-ae").removeClass("activecc");
    $(this)
      .closest(".customizeSelector")
      .find(".active-radio-ae")
      .addClass("activecc");
    $(opts.inputField).val("");
    if (opts.getSelectedCustomization() == "sticker") {
      $(".product-customizerr-wrap").hide();
      $(".stickers-main-div").show();
      $(".productcustomization-btn").hide();
    } else {
      $(".product-customizerr-wrap").show();
      if (opts.canvasWidth < 615) {
        $(".productcustomization-btn").show();
      }
      $(".stickers-main-div").hide();
    }
  });

  $(opts.getStickerMediaEle).on("change", function (e) {
    $(".customizeSelector").find(".active-radio-ae").removeClass("activecc");
    $(this)
      .closest(".customizeSelector")
      .find(".active-radio-ae")
      .addClass("activecc");
    $(opts.inputField).val("");
    if (opts.getSelectedCustomization() == "sticker") {
      $(".product-customizerr-wrap").hide();
      $(".stickers-main-div").show();
    } else {
      $(".product-customizerr-wrap").show();
      $(".stickers-main-div").hide();
    }
  });

  // STICKER CUSTOMIZATION - END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  $(opts.languageSelector).on("change", function (e) {
    $(".languageSelector").find(".active-radio-ae").removeClass("activecc");
    $(this)
      .closest(".languageSelector")
      .find(".active-radio-ae")
      .addClass("activecc");
    $(opts.inputField).val("");
    if (opts.getSelectedLanguage() == "ar") {
      // $("#cc_eng_textbox").hide();
      // $("#cc_arabic_text_icon").show();
      $("#cc_eng_textbox").addClass("ccClicktoOpenMenu");
      $("li[data-id='font_style_baskerville10Pro']").hide();
      $("li[data-id='font_style_laLuxesScript']").hide();
      $("li[data-id='font_style_saucy']").hide();
      $("li[data-id='font_style_atomicmarker']").hide();
      $("li[data-id='font_style_groovy']").hide();
       $("li[data-id='font_style_monotype']").hide();
      $("li[data-id='font_style_script']").hide();
      $("li[data-id='font_style_customFont']").click();

      $(
        "#cc_en_text_icon.dropdown-wrapper .ae-dropdown .dropdown-menu"
      ).removeClass("open");
    } else {
      $("#cc_eng_textbox").removeClass("ccClicktoOpenMenu");
      $(".dropdown-menu").removeClass("open");
      // $("#cc_eng_textbox").show();
      // $("#cc_arabic_text_icon").hide();
      $("li[data-id='font_style_baskerville10Pro']").show();
      $("li[data-id='font_style_laLuxesScript']").show();
      $("li[data-id='font_style_saucy']").show();
      $("li[data-id='font_style_atomicmarker']").show();
      $("li[data-id='font_style_groovy']").show();
       $("li[data-id='font_style_monotype']").show();
      $("li[data-id='font_style_script']").show();
    }

    opts.removeExistingCustomFontText(opts.selectObject("alphabet_svg", "all"));
  });

  $("#cc_eng_textbox .icon-heart-focus").click(function () {
    if (opts.getSelectedLanguage() == "ar") {
      $(
        "#cc_en_text_icon.dropdown-wrapper .ae-dropdown .dropdown-menu"
      ).removeClass("open");
      $(
        "#cc_arabic_text_icon.dropdown-wrapper .ae-dropdown .dropdown-menu"
      ).toggleClass("open");
    } else {
      $(
        "#cc_arabic_text_icon.dropdown-wrapper .ae-dropdown .dropdown-menu"
      ).removeClass("open");
      $(
        "#cc_en_text_icon.dropdown-wrapper .ae-dropdown .dropdown-menu"
      ).toggleClass("open");
    }
  });

  $(document).on("click", opts.inputOptionsSelector, function () {
    let ele = $(this),
      parent = ele.closest(".customizer-wrapper"),
      wrapType = parent.data("option-type");

    if (wrapType === "textColor") {
      console.log($(this).val(), "ttttt");
      if (!opts.restrictToDrawOnCanvas()) {
        return false;
      }
      if ($("variant-image").length) {
        $(`variant-image input[value="${$(this).val()}"]`).click();
      }
    } else if (wrapType === "fontFamily") {
      $(opts.inputField).val("");
      opts.applyFontOnHelperElement();
      // apply some fontsize, coordinates calc based on font type
      opts.setCoordinatesBasedOnFont(ele.data("option-value"));

      // max length input limit
      opts.setInputLimitBaseOnFontType(ele.data("option-value"));
    }

    parent.find(".variant-picker__input").removeClass("active");
    ele.parent().addClass("active");
    console.log("ele.val()",ele.val())
    parent.find(".form__label .selected-value").html(ele.val());

    opts.changeCanvasTextObject(wrapType);
  });

  $("input[name='Font Style']").change(function () {
    $("input[name='initial']").val("");
  });

  $(document).on("click", ".pdp-fs-list", function () {
    $(this).toggleClass("active");
  });

  $(document).on("click", ".pdp-fs-list ul li", function () {
    if ($(this).hasClass("active")) {
      return;
    }
    $(".pdp-fs-list ul li").removeClass("active");
    $(this).addClass("active");
    $(".selected-font-style img").attr("src", $(this).find("img").attr("src"));
    $("#" + $(this).data("id")).click();
    //alert($(this).data("id"));
    //alert($(this).find('img').attr('src'));
  });

  return {
    init: createCanvas,
    switchColorSwatch: switchProductImage,
    // selectArAlphabet: selectArAlphabet
  };
})();

$(function () {
  lanejCustomizer.init();
});

var selectArAlphabet = function (char, image) {
  let currentText = $('input[name="initial"]').val();
  console.log("currentText", currentText);
  console.log("char", char);
  if (currentText.length > 7) {
    return false;
  }
  console.log("$('input[", $('input[name="lanej_language"]').val());
  if ($('input[name="lanej_language"]').val() == "ar") {
    $('input[name="initial"]').val(currentText + char);
  } else {
    $('input[name="initial"]').val(currentText + char);
  }
  $('input[name="initial"]').keyup();
};

$(document).ready(function () {
  console.log($("#termsText p").text(), "getttext");
});

// $(".prod__option--textPosition .inline-flex.flex-wrap .active-radio-ae").click(function(){
//   console.log("Change radio");
//   // $(this).find("input[type='radio']").click();
// })
console.log("LANEJ TOP RIGHT CUSTOMIZABLE::");
